export default import.meta.ROLLDOWN_FILE_URL_4PCAH7nBbIBw3Gpj23tjgg